
import { Options, Vue } from 'vue-class-component'
import Hero from './components/Hero.vue'
import Gallery from './components/Gallery.vue'

@Options({
  components: {
    Hero,
    Gallery
  }
})
export default class App extends Vue {}
